<template>
    <v-dialog
        :value="isOpen"
        max-width="400px"
        max-height="600px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onAbort"
        @click:outside="onAbort"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Czas usunięcia awarii
                </h1>
            </v-card-title>

            <v-card-text class="text-center">
                <v-row justify="center">
                    <v-col cols="12" sm="6">
                        <v-text-field
                            v-model.number="accident.declaredFixTime"
                            type="number"
                            min="1"
                            label="minut"
                            required
                            dense
                            outlined
                            hide-details
                        />
                    </v-col>
                </v-row>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    :disabled="loading"
                    data-sentry-label="Anuluj"
                    @click="onAbort"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    :loading="loading"
                    data-sentry-label="Potwierdź"
                    @click="onSave"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'DeclaredFixedTimeDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        loading: {
            type: Boolean
        },
        accidentData: {
            type: Object,
            default: null
        },
    },
    data() {
        return {
            accident: {
                declaredFixTime: null
            }
        }
    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                this.accident = JSON.parse(JSON.stringify(this.accidentData))
            } else {
                setTimeout(() => {
                    this.accident.declaredFixTime = null
                }, 500)
            }
        }
    },
    methods: {
        onSave() {
            this.$emit('on-save', this.accident)
        },
        onAbort() {
            this.$emit('on-abort')
        }
    }
}
</script>